/* eslint-disable default-param-last */
import {
  APPLY_FILTER,
  CLEAR_RECENT_SEARCH,
  REMOVE_SELECTED_RECENT,
  RESET_FILTER,
  SET_MAX_PRICE_FILTER,
  SET_REGION_FILTER,
  SET_TYPE_FILTER,
  SET_PROVINCE_FILTER,
  SET_NPA_FILTER,
  SET_MIN_PRICE_FILTER,
  SET_TEXT_FILTER,
  SET_SUB1_FILTER,
  SET_WEIGHT_FILTER,
  SET_WHEELS_FILTER,
  SET_ASSISTED_FILTER,
  SET_YEAR_FILTER,
  SET_BRAND_FILTER,
  SET_SIZE_FILTER
} from 'constants/constants';

const initState = {
  recent: [],
  keyword: '',
  minPrice: 0,
  maxPrice: 0,
  sortBy: '',
  npa: '',
  region: '',
  province: '',
  type: '',
  year: '',
  assisted: '',
  brand: '',
  size: '',
  weight: '',
  wheels: '',
  sub1: ''
};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_TEXT_FILTER:
      return {
        ...state,
        recent:
          !!state.recent.find((n) => n === action.payload) ||
          action.payload === ''
            ? state.recent
            : [action.payload, ...state.recent],
        keyword: action.payload
      };
    case SET_TYPE_FILTER:
      return {
        ...state,
        type: action.payload
      };
    case SET_SUB1_FILTER:
      return {
        ...state,
        sub1: action.payload
      };
    case SET_YEAR_FILTER:
      return {
        ...state,
        year: action.payload
      };
    case SET_BRAND_FILTER:
      return {
        ...state,
        brand: action.payload
      };
    case SET_ASSISTED_FILTER:
      return {
        ...state,
        assisted: action.payload
      };
    case SET_WEIGHT_FILTER:
      return {
        ...state,
        weight: action.payload
      };
    case SET_SIZE_FILTER:
      return {
        ...state,
        size: action.payload
      };
    case SET_WHEELS_FILTER:
      return {
        ...state,
        wheels: action.payload
      };
    case SET_REGION_FILTER:
      return {
        ...state,
        region: action.payload
      };
    case SET_PROVINCE_FILTER:
      return {
        ...state,
        province: action.payload
      };
    case SET_NPA_FILTER:
      return {
        ...state,
        npa: action.payload
      };
    case SET_MAX_PRICE_FILTER:
      return {
        ...state,
        maxPrice: action.payload
      };
    case SET_MIN_PRICE_FILTER:
      return {
        ...state,
        minPrice: action.payload
      };
    case RESET_FILTER:
      return initState;
    case CLEAR_RECENT_SEARCH:
      return {
        ...state,
        recent: []
      };
    case REMOVE_SELECTED_RECENT:
      return {
        ...state,
        recent: state.recent.filter((item) => item !== action.payload)
      };
    case APPLY_FILTER:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};
